var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F5F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.54 13C14.6 13.89 14.75 14.76 14.99 15.59L13.79 16.79C13.38 15.59 13.12 14.32 13.03 13H14.54ZM24.4 25.02C25.25 25.26 26.12 25.41 27 25.47V26.96C25.68 26.87 24.41 26.61 23.2 26.21L24.4 25.02ZM15.5 11H12C11.45 11 11 11.45 11 12C11 21.39 18.61 29 28 29C28.55 29 29 28.55 29 28V24.51C29 23.96 28.55 23.51 28 23.51C26.76 23.51 25.55 23.31 24.43 22.94C24.33 22.9 24.22 22.89 24.12 22.89C23.86 22.89 23.61 22.99 23.41 23.18L21.21 25.38C18.38 23.93 16.06 21.62 14.62 18.79L16.82 16.59C17.1 16.31 17.18 15.92 17.07 15.57C16.7 14.45 16.5 13.25 16.5 12C16.5 11.45 16.05 11 15.5 11Z",
    fill: "#4C5C68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.db220d55ffa0cc7a8cd3b1bec71860ba.svg";
export { ForwardRef as ReactComponent };